mobileSize = 1050;

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1051) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1050) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // // Navigation
  $('.saffireLargeSize #mainNavigation .group a').each(function() {
    const navItem = $(this).text();
    const firstWord = navItem.replace(/ .*/,'');
    const newItem = navItem.replace(firstWord, '');

    $(this).text(newItem);
    $('<span class="bold">' +firstWord+ '</span>').prependTo(this);
    $('.items .item a span').removeClass('bold');
    $('.m-groups .m-group a span').removeClass('bold');
  });

  // Search Box
  $('.searchBox').hover(function(){
		$('.nav').fadeOut();
	},
	function(){
		$('.nav').fadeIn();
	});

  // Email Signup
  $('.homepage .emailSignup .emailInputField input')
    .attr('value', 'Enter Email Address')
    .attr('onclick', 'ClearDefaultText(this, "Enter Email Address");');
  $('.homepage .emailSignup .emailSubmitButton').text('SUBSCRIBE');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
});